import React from "react";
import { useFela } from "react-fela";

import { Grid } from "@/components/Grid";
import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import Oval from "@/icons/oval-copy-10.svg";

import { IContentSection } from "./types";

type IProps = IContentSection & JSX.IntrinsicElements["div"];

export const ContentSection: React.FC<IProps> = ({
  title,
  children,
  ...rest
}) => {
  const { css } = useFela();
  const { bp, colors } = useTheme();

  const offset = 516;

  return (
    <Grid
      id="ContentSection"
      customStyle={{
        position: "relative",
        flexDirection: "column",
        [bp.FROM_TABLET]: {
          minHeight: `calc(100vh - ${offset}px)`,
        },
      }}
      {...rest}
    >
      <div
        className={css({
          top: -168,
          position: "absolute",
          transform: "rotate(90deg)",
          display: "none",
          [bp.FROM_DESKTOP]: { display: "block", left: "-25vw" },
          [bp.FROM_LARGE_DESKTOP]: {
            left: "-20vw",
          },
          nested: {
            "@media (min-width: 1800px)": { left: "-25vw" },
          },
        })}
      >
        <Oval />
      </div>

      {title && (
        <Heading
          as="h1"
          customStyle={{
            fontSize: 28,
            color: colors.DARK_GREY,
            textAlign: "left",
            [bp.FROM_DESKTOP]: {
              fontSize: 48,
            },
          }}
        >
          {title}
        </Heading>
      )}
      {children && (
        <div
          className={css({
            nested: {
              "> p": {
                fontSize: 16,
                lineHeight: 1.44,
                letterSpacing: 0.5,
                color: colors.DARK_GREY,
                [bp.FROM_DESKTOP]: {
                  fontSize: 18,
                },
              },
            },
          })}
        >
          {children}
        </div>
      )}
    </Grid>
  );
};
